module.exports = "Sorry You Don't have permission to access this feature\r\n\r\n"